
import { defineComponent, PropType } from 'vue';
import Cronometer from './Cronometer.vue';
import ITask from '../interfaces/ITask'
import Box from './Box.vue'

export default defineComponent({
  name: "Task",
  components: {
    Cronometer,
    Box
  },
  props: {
    task: {
      type: Object as PropType<ITask>,
      required: true
    }
  }
});
